module.exports = __webpack_public_path__ + "img/img_popup_lock_quota@2x.3d86f223.png";